module.exports = __webpack_public_path__ + "img/CENZ.4cbabffc.svg";